module.exports = __webpack_public_path__ + "img/bg_banner_fees_page.62b28a83.png";